import { useEffect } from "react";
import { Outlet } from "react-router";
import { useAuth } from "~/context/AuthContext";
import { useLocation, useNavigate } from "~/lib/team-router";

const NO_WORKSPACE_PATH = "/no-workspace";

export default function OnboardingGuard() {
  const { user, isLoading, isAuthenticated, isOnboardingComplete } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const hasNoWorkspace =
    isOnboardingComplete && !user?.agency && !user?.teams?.length;
  const isOnNoWorkspacePage = location.pathname.startsWith(NO_WORKSPACE_PATH);

  useEffect(() => {
    if (isLoading) return;

    if (!isAuthenticated) {
      navigate("/login");
      return;
    }

    if (isAuthenticated && !isOnboardingComplete) {
      if (user?.pending_agency_signup) {
        if (!location.pathname.startsWith("/agencies/onboarding")) {
          navigate("/agencies/onboarding");
        }
        return;
      }
      if (!location.pathname.startsWith("/onboarding")) {
        navigate("/onboarding");
      }
      return;
    }

    if (
      isAuthenticated &&
      isOnboardingComplete &&
      (location.pathname.startsWith("/onboarding") ||
        location.pathname.startsWith("/agencies/onboarding"))
    ) {
      navigate("/");
      return;
    }

    if (hasNoWorkspace && !isOnNoWorkspacePage) {
      navigate(NO_WORKSPACE_PATH, { replace: true });
      return;
    }

    if (!hasNoWorkspace && isOnNoWorkspacePage) {
      navigate("/", { replace: true });
    }
  }, [
    isAuthenticated,
    isOnboardingComplete,
    isLoading,
    location.pathname,
    navigate,
    user,
    hasNoWorkspace,
    isOnNoWorkspacePage,
  ]);

  if (isLoading) return;

  if (!isAuthenticated) return;

  if (
    !isOnboardingComplete &&
    !location.pathname.startsWith("/onboarding") &&
    !location.pathname.startsWith("/agencies/onboarding")
  ) {
    return;
  }

  if (
    isOnboardingComplete &&
    (location.pathname.startsWith("/onboarding") ||
      location.pathname.startsWith("/agencies/onboarding"))
  ) {
    return;
  }

  if (hasNoWorkspace !== isOnNoWorkspacePage) {
    return;
  }

  return <Outlet />;
}
